<template>
	<component :is="currentDashboard" />
</template>

<script>
import { computed, defineComponent } from 'vue';
import { authUser } from '../store';
import DashboardView from '@/views/Dashboard.vue';
import DashboardVorstandVue from './DashboardVorstand.vue';
import DashboardWerberatView from './DashboardWerberatView.vue';

export default defineComponent({
	name: 'DashboardWrapper',
	components: {
		DashboardView,
	},
	setup() {
		const currentDashboard = computed(() => {
			const authUserRoles = authUser.value.roles.map((role) => role.name);
			if (authUserRoles.includes('Vorstand')) {
				return DashboardVorstandVue;
			} else if (
				authUserRoles.includes('Werberat') ||
				authUserRoles.includes('Junger Werberat') ||
				authUserRoles.includes('Kleiner Senat A') ||
				authUserRoles.includes('Kleiner Senat B')
			) {
				return DashboardWerberatView;
			} else {
				return DashboardView;
			}
		});

		return {
			currentDashboard,
		};
	},
});
</script>
